<template>
  <vuestic-widget>
    <div v-if="loadingData">
      <div class="col-md-12 mt-12 mb-3 d-flex justify-content-center">
        <strong class="font-weight-bold">Carregando os dados do aluno...</strong>
      </div>
      <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
        <div class="btn-toolbar form-group" role="toolbar" aria-label="Toolbar with button groups">
          <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
        </div>
      </div>
    </div>

    <div v-else>
      <div v-if="aulas_regulares.length === 0 && aulas_reposicao.length === 0" class="aulas-empty-container">
        <AulasEmpty title="Nenhuma aula encontrada."
          description="Parece que você ainda não tem nenhuma aula registrada em nosso sistema." center="center" />

        <img src="~/assets/aulasEmpty.png" alt="">
      </div>

      <div v-else>
        <header class="historico-header">
          <img src="~/assets/reClock.svg" alt="">
          <span>Histórico das aulas</span>
        </header>

        <div class="card col-12" :style="cardStyle" v-for="(aula, index) in aulas_regulares.concat(aulas_reposicao)"
          :key="index">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="card-title fa fa-book fa-2x" :style="titleStyle">
                <strong style="font-size: 19px; padding-left: 3px; font-family: Arial, Helvetica, sans-serif;">
                  {{ aula.materia.titulo }}
                </strong>
              </h4>
              <div :style="dateStyle" class="d-inline-flex aligned-text">
                {{ formatDate(aula.inicio) }} - {{ formatDateFim(aula.fim) }}
              </div>
            </div>
            <v-card-actions>
              <span v-if="aula.turma.cancelada">CANCELADA</span>
              <span
                v-else-if="new Date(aula.inicio.replace(/-/g, '/')) < Date.now() && getPresenca(aula) === 'Realizada'">
                <i class="fa fa-check-circle-o" style="color: green; padding-right: 3px;"></i> <i
                  style="font-weight: bold; padding-right: 5px;">Realizada </i>
                <i style="color: #1E2F5B;"> {{ id === aulas_regulares ? 'Aula comum' : 'Aula reposição' }} </i>
              </span>
              <span
                v-else-if="new Date(aula.inicio.replace(/-/g, '/')) < Date.now() && getPresenca(aula) === 'Não realizada'">
                <i class="fa fa-times-circle" style="color: red; padding-right: 3px;"></i> <i
                  style="font-weight: bold; padding-right: 5px;">Não realizada </i>
                <i style="color: #1E2F5B;"> {{ id === aulas_regulares ? 'Aula comum' : 'Aula reposição' }} </i>
              </span>
              <span v-else>-</span>
            </v-card-actions>
            <v-card-actions>
              <span v-if="verifyPresenca(aula, '0')">
                <i class="fa fa-check-circle-o" style="color: green; padding-right: 3px;"></i> <i
                  style="font-weight: bold; padding-right: 5px;">Entrada registrada</i>
              </span>
              <span v-else>
                <i class="fa fa-times-circle" style="color: red; padding-right: 3px;"></i> <i
                  style="font-weight: bold; padding-right: 5px;">Entrada não registrada</i>
              </span>
            </v-card-actions>
            <v-card-actions>
              <span v-if="verifyPresenca(aula, '1')">
                <i class="fa fa-check-circle-o" style="color: green; padding-right: 3px;"></i> <i
                  style="font-weight: bold; padding-right: 5px;">Saída registrada</i>
              </span>
              <span v-else>
                <i class="fa fa-times-circle" style="color: red; padding-right: 3px;"></i> <i
                  style="font-weight: bold; padding-right: 5px;">Saída não registrada</i>
              </span>
            </v-card-actions>
          </div>
        </div>
      </div>
    </div>
  </vuestic-widget>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApi from '../../router/urlApiV2'
import AulasEmpty from './componentes/aulas-empty.vue'

export default {
  components: {
    ...spinners,
    AulasEmpty
  },
  computed: {
    cardStyle() {
      return {
        borderRadius: '15px',
        marginTop: '1%',
      }
    },
    titleStyle() {
      return {
        color: '#606060',
      }
    },
    dateStyle() {
      return {
        marginLeft: '5%',
        paddingLeft: '1%',
        paddingRight: '1%',
        color: 'white',
        backgroundColor: '#606060',
        borderRadius: '50px',
      }
    },
  },
  data() {
    return {
      nome: '',
      cpf: '',
      categoria: '',
      foto: '',
      aulas_regulares: [],
      aulas_reposicao: [],
      loadingData: false,
      autoescola: window.localStorage['nome_fantasia'] != 'null' ? window.localStorage['nome_fantasia'].toUpperCase() : ''
    }
  },
  async mounted () {
    await this.extraData()
  },
  methods: {
    async extraData() {
      this.loadingData = true

      await this.$http.get(urlApi + '/alunos/consultar/detalhes?schema=' + window.localStorage['schema'])
        .then((response) => {
          this.nome = response.body.dados.candidato.nome
          this.cpf = response.body.dados.candidato.cpf
          this.categoria = response.body.dados.candidato.categoria
          this.foto = response.body.dados.candidato.foto
          this.aulas_regulares = response.body.dados.aulas_regulares
          this.aulas_reposicao = response.body.dados.aulas_reposicao
          this.loadingData = false
        }).catch((error) => {
          this.launchToast(error.body.mensagem)
          this.loadButton = false;
        })
    },
    cpfFormat(cpf) {
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    },
    getPresenca(aula) {
      if (aula.presencas.length === 0) {
        return 'Não realizada'
      } else {
        return 'Realizada'
      }
    },
    verifyPresenca(aula, tipo) {
      if (aula.presencas.length === 0) {
        return false
      }

      const presencaEncontrada = aula.presencas.some(presenca => presenca.tipo === tipo)

      return presencaEncontrada
    },
    formatDateFim(datetimeString) {
      const options = {
        hour: '2-digit',
        minute: '2-digit',
      }
      const date = new Date(datetimeString)
      const formattedTime = `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
      return formattedTime
    },
    formatDate(datetimeString) {
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      }
      const date = new Date(datetimeString)
      const formattedDate = date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      const formattedTime = `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
      return `${formattedDate}, ${formattedTime}`
    },
  }
}
</script>

<style scoped>
.historico-header {
  padding: 2rem 0;

  display: flex;
  align-items: center;
  gap: 1rem;
}

.historico-header>span {
  color: #1E2F5B;
  font-size: 1.5rem;
  font-weight: 700;
}

.aulas-empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;

}
</style>
